var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgContactUsBlueHover(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#2363F7",
    d: "M8,0 C12.418278,0 16,3.581722 16,8 C16,12.418278 12.418278,16 8,16 C3.581722,16 0,12.418278 0,8 C0,3.581722 3.581722,0 8,0 Z M8,0.8 C4.0235498,0.8 0.8,4.0235498 0.8,8 C0.8,11.9764502 4.0235498,15.2 8,15.2 C11.9764502,15.2 15.2,11.9764502 15.2,8 C15.2,4.0235498 11.9764502,0.8 8,0.8 Z M8.04418605,6.31860465 C8.35242791,6.31860465 8.60232558,6.56850233 8.60232558,6.87674419 L8.60232558,11.3418605 C8.60232558,11.6501023 8.35242791,11.9 8.04418605,11.9 C7.73594419,11.9 7.48604651,11.6501023 7.48604651,11.3418605 L7.48604651,6.87674419 C7.48604651,6.56850233 7.73594419,6.31860465 8.04418605,6.31860465 Z M8.04418605,3.9 C8.4552,3.9 8.78837209,4.23318698 8.78837209,4.64418605 C8.78837209,5.05518512 8.4552,5.38837209 8.04418605,5.38837209 C7.63317209,5.38837209 7.3,5.05518512 7.3,4.64418605 C7.3,4.23318698 7.63317209,3.9 8.04418605,3.9 Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgContactUsBlueHover);
export default __webpack_public_path__ + "static/media/contactUs_blue_hover.79454f1d774ba78ea00765b0cb50a6ba.svg";
export { ForwardRef as ReactComponent };